import {
  Component,
  effect,
  ElementRef,
  inject,
  signal,
  viewChild
} from '@angular/core';
import { PasswordToggleComponent } from '../password-toggle/password-toggle.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule, ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { ToastService } from 'src/app/services/Toast/toast.service';
import { SpinnerComponent } from '../spinner/spinner.component';
import { Router, RouterLink } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ModalsService } from 'src/app/services/Modals/modals.service';
import { FieldErrorComponent } from "../field-error/field-error.component";
import { DialogBackdropDirective } from '../directives/dialog-backdrop/dialog-backdrop.directive';
@Component({
  selector: 'login-modal',
  imports: [
    PasswordToggleComponent,
    ReactiveFormsModule,
    SpinnerComponent,
    RouterLink,
    FormsModule,
    FieldErrorComponent,
    DialogBackdropDirective
],
  templateUrl: './login-modal.component.html',
  styleUrl: './login-modal.component.scss',
})
export class LoginModalComponent {
  // refs
  dialog = viewChild<ElementRef<HTMLDialogElement>>('login_modal');

  // injectables
  toast = inject(ToastService)
  fb = inject(FormBuilder)
  auth = inject(AuthService)
  router = inject(Router)
  modal = inject(ModalsService)

  // consts
  google_client_id = environment.google_client_id;

  // states
  showPassword = signal<boolean>(false);
  loading = signal<boolean>(false);
  error_message = signal<string>('');
  submitted = signal<boolean>(false)

  // DATA
  form!: FormGroup;

  constructor() {
    this.initForm();

    effect(() => {
      this.loading() ? this.form.disable() : this.form.enable();
    });
  }

  ngOnInit() {
    const toast_data = localStorage.getItem('x-notify') // Maybe refactor this later, and make use of it other than just indicator
    // E.g store with actual toasst type and message
    if (toast_data) {
      localStorage.removeItem('x-notify')
      this.toast.makeToast('info', 'Session Expired!', 5000) 
    }
  }

  ngOnDestroy() {
    this.dialog()?.nativeElement.close();
  }
  initForm() {
    this.form = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(100)],
      ],
      password: ['', Validators.required],
      remember: [true]
    });
  }

  onError(message: string) {
    this.loading.set(false);
    this.error_message.set(message);
  }

  apiLogin() {
    this.loading.set(true);
    const {
      email,
      password, 
      remember
    } = this.form.getRawValue()

    this.auth.login(email, password, remember).subscribe({
      error: (err) => {
        this.onError(err.error.message);
      },
      complete: () => this.onLoginSuccess(),
    });
  }

  onLoginSuccess() {
    this.onDismiss();
    this.router.navigate([this.auth.getRoleIndex()]);
    this.toast.makeToast('success', 'Logged in successfully', 5000);
  }

  submit() {
    this.submitted.set(true)
    if (!this.form.valid) {
      return;
    }

    this.error_message.set('');
    this.apiLogin();
  }

  onDismiss() {
    this.dialog()?.nativeElement.close()
  }
  onShow() {
    this.initForm();
    this.dialog()?.nativeElement.show()
    this.submitted.set(false)
  }
  openGoogleLogin() {
    const url = this.auth.getOauthUrl();
    const windowName = 'Sign in with google';
    const features =
      'width=500,height=600,resizable=no,scrollbars=no,status=no,toolbar=no,location=no,menubar=no';
    const popup = window.open(url, windowName, features);
    // popup?.addEventListener('unload', () => console.log('test'));

    const interval = setInterval(() => {
      if (popup?.closed) {
        clearInterval(interval);
        this.onOAuthClosed();
      }
    }, 500);
  }
  onOAuthClosed() {
    if (this.auth.isAuthenticated()) {
      this.router.navigate([this.auth.getRoleIndex()]);
      return;
    }

    const error = localStorage.getItem('oauth_error');

    if (error) {
      this.modal
        .getInstance()
        .showInfo(
          'Unauthorized',
          'Unauthorized user. Please contact the administrator to create an account for you.',
          'Okay',
          () => localStorage.removeItem('oauth_error'),
        );
    }

    // else {
    //   // this handle user blocked or cancelled
    //   this.modal.getInstance().showInfo(
    //     'Authentication Failed',
    //     'Unable to complete Google sign-in. Please try again or contact support for assistance.',
    //     'Okay'
    //   );
    // }
  }

  toggleShowPassword() {
    this.showPassword.update((x) => !x)
  }
}
